<template lang="html">

	<footer class="footer">

		<section class="title">
			<span>{{ title }}</span>
		</section>
		<section class="campus">
			<div v-for="campus in $t('footer.campus')">
				<p class="name">{{ campus.title }}</p>
				<p>{{ campus.subtitle }}</p>
				<p>
					<i class="fa fa-map-marker" aria-hidden="true"></i>
					{{campus.direction}}
				</p>
				<a :href="'tel:'+campus.tel"> <i class="fa fa-phone" aria-hidden="true"></i>{{ campus.tel }}</a>
			</div>
		</section>

		<section class="container-contact">
			<div class="container-logos">
				<img src="/static/img/brands/euncet/logo-white.png" alt="Logo Euncet">
				<img :src="'/static/img/brands/euncet/logo-universidad-'+$i18n.locale+'.png'" alt="Logo Universidad">
			</div>
			<div class="contact">
				<h4>{{ contact.title }}</h4>
				<a :href="`mailto:${contact.email}`">
					<i class="fa fa-envelope" aria-hidden="true"></i>
					{{ contact.email }}
				</a>
				<a :href="`tel:${contact.phone}`">
					<i class="fa fa-phone" aria-hidden="true"></i>
					{{ contact.phone }}
				</a>
			</div>
			<div class="rrss">
				<h4>{{ rrss.title }}</h4>
				<div class="content">
					<a v-for="(item, key) in rrss.items" :href="item" :data="key" target="_blank">
						<img v-if="key == 'twitter' || key == 'tiktok'" :src="`/static/img/icons/${key}.svg`" />
						<i v-else :class="`fa fa-${key}`" aria-hidden="true"></i>
					</a>
				</div>
			</div>
		</section>

		<div class="footer-container row-between" :withoutMT="withoutMT">

			<nav class="bottom row-center" v-if="!!links">

				<template v-for="(data, key) in links">

					<a :href="data" target="_blank">{{key}}</a>

				</template>

				<idioma></idioma>

			</nav>

			<div class="top row-center">
				<template v-for="t in texts" v-if="!!texts">
					<p v-html="t"></p>
				</template>
			</div>

		</div>
		<p class="version">v.{{version}}</p>


	</footer>

</template>

<script lang="js">
	
	import {mapGetters} from 'vuex';
	

	import idioma from '@/components/parts/idioma';

	export default  {
		name: 'app-footer',
		computed : {
			...mapGetters({
				colors : 'basicColors',
				texts : 'getFooterText',
				links : 'getFooterLinks',
				version : 'getVersion',
				brand: 'getBrand',
				title: 'getFooterTitle',
				contact: 'getFooterContact',
				rrss: 'getFooterRRSS'
			}),
			ownstyles : function(){
				return {
					bgWhite : {
						background : this.colors.white
					}
				}
			},
			withoutMT : function(){
				let views = [
				'/login',
				'/login/empresas',
				'/login/antiguos',
				'/login/alumnos',
				'/mantenimiento',
				'/acceso',
				'/gma2019',
				];
				return (views.some(el => el == this.$route.path));
			}
		},
		components : {
			'idioma' : idioma
		}
	}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/parts/footer.vue